import { createSlice } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from 'services/api';

export const clientSubUserInitialState = {
  subUser: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  current_page: 1,
  per_page: PAGELENGTH,
};

export const clientSubUserSlice = createSlice({
  name: 'clientSubUser',
  initialState: clientSubUserInitialState,
  reducers: {
    setClientSubUser: (state, { payload }) => {
      state.subUser = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setClientSubUsers: (state, { payload }) => {
      state.subUser = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setMoreClientSubUsers: (state, { payload }) => {
      state.subUser = state.subUser.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    removeClientSubUser: (state, { payload }) => {
      state.error = payload;
    },
    clearAllClientSubUser: (state, { payload }) => {
      state.loader = payload;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
    setLoader: (state, { payload }) => {
      state.loader = payload;
    },
  },
});

export const addClientSubUsers = (data, callback) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const json = await Api.addClientSubUsers(data);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

export const updateClientSubUsers = (data, itemId, callback) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const json = await Api.updateClientSubUsers(data, itemId);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

export const removeClientSubUsers = (itemId, callback) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const json = await Api.removeClientSubUsers(itemId);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

export const fetchClientSubUsers = (page, params, disableLoader) => async (dispatch) => {
  if (!disableLoader) dispatch(setLoader(true));
  try {
    const result = await Api.fetchClientSubUsers(page, params);
    if (result.status >= 200 && result.status < 300) {
      dispatch(setClientSubUsers(result.data.data));
    } else if (result?.status === 422) {
      dispatch(setError(result.data));
    }
  } catch (error) {
    console.log('error', error);
  }
  if (!disableLoader) dispatch(setLoader(false));
};

export const changeClientSubUserStatus = (id, data) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const json = await Api.clientStatusChange(id, data, 'account/sub-users');
    if (json.status >= 200 && json.status < 300) {
      // success
    } else if (json.status === 422) {
      dispatch(setError(json.data));
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

export const removeMultipleClientSubUsers = (ids, callback) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const json = await Api.removeMultipleClientSubUsers(ids);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

export const {
  setClientSubUser,
  setClientSubUsers,
  setMoreClientSubUsers,
  removeClientSubUser,
  clearAllClientSubUser,
  setError,
  setLoader,
} = clientSubUserSlice.actions;

export default clientSubUserSlice.reducer;
export const clientSubUserSelector = (state) => state.clientSubUser;
